export const STORAGE: Record<string, string> = {
	Storage: "Lager",
	"Settings and storage": "Indstillinger og lager",
	Documents: "Dokumenter",
	Recents: "Seneste",
	Folder: "Mappe",
	Link: "Link",
	Markdown: "Markdown",
	"Text document": "Tekstdokument",
	"Date modified": "Ændret",
	Size: "Størrelse",
	"File type": "Filtype",
	"Sort files": "Sortér filer",
	"File view": "Filvisning",
	"All types": "Alle typer",
	Folders: "Mapper",
	Spreadsheets: "Regneark",
	Images: "Billeder",
	PDFs: "PDF-filer",
	Links: "Links",
	"Other files": "Andre filer",
	"Icon view": "Ikonvisning",
	"List view": "Listevisning",
	"No files of this type in this folder.": "Ingen filer af denne type i mappen.",
	"{shown} of {count} loaded items": "{shown} af {count} indlæste elementer",
	"{count} items": "{count} elementer",
	"{shown} of {count} items": "{shown} af {count} elementer",
	Yesterday: "I går",
	"No recent changes match your search.": "Ingen seneste ændringer matcher din søgning.",

	// HTML pages and folder links (app/views/company-folder.ts, ui/markdown.ts)
	Page: "Side",
	Source: "Kilde",
	"Show the page or its source": "Vis siden eller dens kilde",
	"Page: {name}": "Side: {name}",
	"Show {name} large": "Vis {name} stort",
	"This page can't be shown live, so its source is shown.": "Siden kan ikke vises direkte, så dens kilde vises.",
	"Open {path} in Storage": "Åbn {path} i Lager",
	"{name} could not be found in the Company File.": "{name} findes ikke i Virksomhedsfilen.",
};
